import FrontendEvents from "./FrontendEvents.vue";

export default [{
    path: "/Admin/FrontendEvents",
    component: FrontendEvents,
    name: "FrontendEvents",
    meta: {
        name: "Frontend Events",
        app: "Admin",
        appSwitcher: false,
        appSwitcherPosition: 25,
        sideNav: true,
        sideNavPosition: 5,
        sideNavSection: "Admin",
        icon: "bug",
        security: "General.ApplicationAdmin",
        lock(user) {
            return [user?.Security?.General?.ApplicationAdmin !== true, "Cannot view this area"];
        },
    }
}];
